import script from "C:\\Users\\estag\\Documents\\Projetos Kryzalis\\a\\alpinvestimentos.com.br\\front\\src\\js\\components\\KCoockies.vue?type=script"
export * from "C:\\Users\\estag\\Documents\\Projetos Kryzalis\\a\\alpinvestimentos.com.br\\front\\src\\js\\components\\KCoockies.vue?type=script"
export default script